<app-brain-tab [theme]="theme"></app-brain-tab>
